import DOMPurify from "dompurify";
import { toAbsolutePublicUrl } from "../../../services/mediaLibraryServices";

export const FALLBACK_PUBLIC_PAGE_HERO = "/img/hero-default.jpg";

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function isExternalUrl(value = "") {
  return /^https?:\/\//i.test(String(value || "").trim());
}

export function normalizeRedirectUrl(value = "") {
  return String(value || "").trim();
}

export function resolvePageImage(value = "") {
  const image = String(value || "").trim();

  if (!image) return FALLBACK_PUBLIC_PAGE_HERO;
  if (isExternalUrl(image)) return image;
  if (image.startsWith("/")) return image;

  return toAbsolutePublicUrl(image) || FALLBACK_PUBLIC_PAGE_HERO;
}

export function stripHtml(html = "") {
  return String(html)
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function getPageDescription(page) {
  return (
    page?.seo_description ||
    page?.subtitle ||
    stripHtml(page?.content_html || "").slice(0, 160)
  );
}

export function sanitizePublicHtml(html = "") {
  return DOMPurify.sanitize(html || "<p>Contenu à venir…</p>", {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: [
      "allow",
      "allowfullscreen",
      "frameborder",
      "scrolling",
      "target",
      "rel",
      "loading",
    ],
  });
}

export function applySeo(page) {
  if (!page) return;

  document.title = page.seo_title || page.title || document.title;

  const description = getPageDescription(page);

  let meta = document.querySelector('meta[name="description"]');

  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "description");
    document.head.appendChild(meta);
  }

  meta.setAttribute("content", description || "");
}